import { useTranslation } from "react-i18next";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

interface TodayFilterPanelOptionProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export const TodayFilterPanelOption = ({
  checked,
  onCheckedChange,
}: TodayFilterPanelOptionProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <Label htmlFor="today-filter">
        {t("contractorVisits.todayFilter.label")}
      </Label>
      <div className="flex justify-between items-center border p-2 rounded-lg">
        <p className="text-sm text-muted-foreground">
          {t("contractorVisits.todayFilter.description")}
        </p>
        <Switch
          id="today-filter"
          checked={checked}
          onCheckedChange={onCheckedChange}
        />
      </div>
    </div>
  );
};
